<template>
  <div class="card-views-shell">
    <BenefitCardListPanel ref="listPanel" />
    <AllNav />
  </div>
</template>

<script>
import AllNav from '../../components/footnav/AllNav.vue';
import BenefitCardListPanel from './components/BenefitCardListPanel.vue';

export default {
  name: 'AllCardViews',
  components: { AllNav, BenefitCardListPanel },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = false;
    next();
  },
  mounted() {
    this.$refs.listPanel.initFromRoute(this.$route);
  },
};
</script>

<style lang="scss" scoped>
.card-views-shell {
  height: 100vh;
  display: flex;
  flex-direction: column;

  :deep(.benefit-card-page) {
    flex: 1;
    min-height: 0;
  }
}
</style>
